"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _text = require("@oneloop/text");
var _hooks = require("@oneloop/hooks");
var _theme = _interopRequireDefault(require("@oneloop/theme"));
var _excluded = ["prefix", "suffix", "label", "errors", "variant", "variantSize", "infoAlert", "disabled", "readonly", "inline", "password", "bold", "width"];
/* eslint-disable react/display-name */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Input = exports.Input = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    label = _ref.label,
    errors = _ref.errors,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'input' : _ref$variant,
    _ref$variantSize = _ref.variantSize,
    variantSize = _ref$variantSize === void 0 ? 'inputLarge' : _ref$variantSize,
    infoAlert = _ref.infoAlert,
    disabled = _ref.disabled,
    readonly = _ref.readonly,
    inline = _ref.inline,
    password = _ref.password,
    bold = _ref.bold,
    width = _ref.width,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useToggle = (0, _hooks.useToggle)(false),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    hover = _useToggle2[0],
    setHover = _useToggle2[1];
  var _useToggle3 = (0, _hooks.useToggle)(false),
    _useToggle4 = _slicedToArray(_useToggle3, 2),
    focused = _useToggle4[0],
    setFocused = _useToggle4[1];
  var _React$useState = _react["default"].useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    text = _React$useState2[0],
    setText = _React$useState2[1];
  var indexVariant = Object.keys(_theme["default"].forms).indexOf(variant);
  var finalVariant = variant + '.normal';
  var colorPlaceholder = Object.values(_theme["default"].forms)[indexVariant].normal.color;
  if (hover) {
    finalVariant = variant + '.hover';
    colorPlaceholder = Object.values(_theme["default"].forms)[indexVariant].hover.color;
  }
  if (focused) {
    finalVariant = variant + '.active';
    colorPlaceholder = Object.values(_theme["default"].forms)[indexVariant].active.color;
  } else if (!focused && text !== '') {
    finalVariant = variant + '.filled';
    colorPlaceholder = Object.values(_theme["default"].forms)[indexVariant].filled.color;
  } else if (disabled) {
    finalVariant = 'inputDisabled';
    colorPlaceholder = 'neutralGray5';
  } else if (readonly) {
    finalVariant = 'inputReadonly';
    colorPlaceholder = 'neutralGray1';
  }
  var index = Object.keys(_theme["default"].forms).indexOf(variantSize);
  var paddingLeft = prefix ? Object.values(_theme["default"].forms)[index].paddingLeftPrefix : Object.values(_theme["default"].forms)[index].paddingLeftNoPrefix;
  var paddingRight = suffix ? Object.values(_theme["default"].forms)[index].paddingRightSuffix : Object.values(_theme["default"].forms)[index].paddingRightNoSuffix;
  var paddingIcons = Object.values(_theme["default"].forms)[index].paddingIcons;
  var fontSizePrefix = Object.values(_theme["default"].forms)[index].fontSize;
  if (suffix && suffix.type !== 'span') {
    suffix = /*#__PURE__*/_react["default"].createElement("div", null, suffix);
  }
  if (infoAlert !== undefined) {
    finalVariant = 'inputFocus';
  } else if (errors !== undefined) {
    finalVariant = 'inputError';
    colorPlaceholder = 'error';
    suffix = /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
      icon: "icon-error",
      fontSize: fontSizePrefix
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    width: "100%",
    __css: {
      display: inline && 'flex',
      flexDirection: inline && 'row',
      alignItems: inline && 'center',
      gap: inline && '16px'
    }
  }, label && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      mb: '4px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: "body600.fontSize12",
    style: {
      color: '#384248'
    }
  }, label)), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      position: 'relative',
      height: 'fit-content',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '6px',
      color: colorPlaceholder,
      fontFamily: 'Nunito Sans',
      fontWeight: bold ? 700 : 400,
      width: width,
      '> *:first-child': prefix ? prefix.type === 'span' ? {
        position: 'absolute',
        left: paddingIcons,
        height: fontSizePrefix,
        fontSize: fontSizePrefix
      } : {
        position: 'absolute',
        left: paddingIcons
      } : {},
      '> *:last-child': suffix ? suffix.type === 'span' ? {
        position: 'absolute',
        right: paddingIcons,
        height: fontSizePrefix,
        fontSize: fontSizePrefix
      } : {
        position: 'absolute',
        right: paddingIcons
      } : {}
    }
  }, prefix, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "input",
    type: password ? 'password' : 'text',
    tx: "forms",
    variant: [finalVariant, variantSize],
    onMouseOver: function onMouseOver() {
      return setHover(true);
    },
    onMouseOut: function onMouseOut() {
      return setHover(false);
    },
    onChange: function onChange(e) {
      return setText(e.target.value);
    },
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    width: "100%",
    ref: ref
  }, props, {
    __css: {
      fontWeight: bold ? 700 : 400,
      border: 'solid 1px transparent',
      boxShadow: 'none',
      fontFamily: 'primary',
      display: 'block',
      paddingLeft: paddingLeft,
      paddingRight: paddingRight,
      outline: 'none'
    }
  })), suffix), errors && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      px: 16,
      py: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: "inputMessageErrors"
  }, errors)), infoAlert && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      px: 16,
      py: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: "inputMessageInfoAlert"
  }, infoAlert)));
});
Input.propTypes = {
  placeholder: _propTypes["default"].string
};
Input.defaultProps = {
  disabled: false
};